import SMHIWarnings from "./SMHIWarnings";
import BrottsplatsKartan from "./BrottsplatsKartan";
import VMA from "./VMA";
import Trafikverket from "./Trafikverket";
import SL from "./SL";
import { Card, Typography, Select, Button } from "antd";
import { useState } from "react";
import SMHIWarningSettings from "./SettingsComponents/SMHIWarningSettings";
import { AlertFilled } from "@ant-design/icons";
import StandardSubSettings from "./SettingsComponents/StandardSubSettings";
import VMASettings from "./SettingsComponents/VMASettings";
import BrottsplatsKartanSettings from "./SettingsComponents/BrottsplatsKartanSettings";
import TrafikverketSettings from "./SettingsComponents/TrafikverketSettings";
import SLSettings from "./SettingsComponents/SLSettings";

const Tile = ({ id, tile, handleTileChange, removeBlock }) => {
  var thisTileData = StandardSubSettings(tile, "Tile");

  const [apiSelected, setAPISelected] = useState(thisTileData.apiSelected);
  const [selected, setSelected] = useState(thisTileData.selected);
  const [activeTab, setActiveTab] = useState(thisTileData.activeTab);

  const [haveNewData, setHaveNewData] = useState(false);

  const saveSettings = (setting) => {
    console.log("going through saveSettings");
    thisTileData.settingsData = setting;
    saveChange();
  };

  const api = [
    {

      comp: <SMHIWarnings
        settings={thisTileData.settingsData}
        setHaveNewData={setHaveNewData} />,


      compSettings: (
        <SMHIWarningSettings
          settings={thisTileData.settingsData}
          saveSettings={saveSettings}
        />
      ),
      title: "SMHI",
      tileColor: "#6D8DFF",
    },
    {
      comp: (
        <BrottsplatsKartan
          setHaveNewData={setHaveNewData}
          settings={thisTileData.settingsData}
          isMobile="false"
        />
      ),
      compSettings: (
        <BrottsplatsKartanSettings
          settings={thisTileData.settingsData}
          saveSettings={saveSettings}
        />
      ),
      title: "BrottsplatsKartan",
      tileColor: "#7EB6AC",
    },
    {
      comp: (
        <VMA
          setHaveNewData={setHaveNewData}
          settings={thisTileData.settingsData}
        />
      ),
      compSettings: (
        <VMASettings
          settings={thisTileData.settingsData}
          saveSettings={saveSettings}
        />
      ),
      title: "VMA",
      tileColor: "#A40000",
    },
    {
      comp: (<Trafikverket
        setHaveNewData={setHaveNewData}
        settings={thisTileData.settingsData}
        isMobile="false" />),

      compSettings: (
        <TrafikverketSettings
          settings={thisTileData.settingsData}
          saveSettings={saveSettings}
        />
      ),

      title: "Trafikverket",
      tileColor: "#ee4f57",
    },
    {
      comp: (
        <SL
          setHaveNewData={setHaveNewData}
          settings={thisTileData.settingsData}
        />
      ),
      compSettings: (
        <SLSettings
          settings={thisTileData.settingsData}
          saveSettings={saveSettings}
        />
      ),
      title: "SL",
      tileColor: "#008ED7",
    },
  ];

  const tabList = [
    {
      key: "tab1",
      tab: api[selected].title,
    },
    {
      key: "tab2",
      tab: "Inställningar",
    },
  ];

  function saveChange() {
    console.log("from saveChange");
    console.log(thisTileData);

    handleTileChange(thisTileData, id);
  }

  const contentList = {
    tab1: api[selected].comp,
    tab2: api[selected].compSettings,
  };

  const changeTab = (key) => {
    setActiveTab(key);
    thisTileData.activeTab = key;

    saveChange();
  };

  const handleChange = (value) => {
    setSelected(value);
    thisTileData.selected = value;

    saveChange();
  };

  const setAPI = () => {
    setHaveNewData(false);
    if (apiSelected) {
      setSelected(0);
      setAPISelected(false);
      thisTileData.apiSelected = false;
    } else {
      setAPISelected(true);
      thisTileData.apiSelected = true;
    }
    saveChange();
  };

  return (
    <>
      {apiSelected ? (
        <Card
          style={{
            backgroundColor: api[selected].tileColor,
            height: "100%",
            overflowY: "auto",
          }}
          tabList={tabList}
          activeTabKey={activeTab}
          tabBarExtraContent={
            <div>
              <Button type="dashed" onClick={setAPI}>
                Ändra API
              </Button>
              {haveNewData && (
                <AlertFilled style={{ color: "yellow", paddingLeft: "15px" }} />
              )}
            </div>
          }
          onTabChange={(key) => changeTab(key)}
        >
          {contentList[activeTab]}
        </Card>
      ) : (
        <Card
          title={
            <Typography.Title level={4} className="tileHeader">
              Välj API
            </Typography.Title>
          }
          style={{
            backgroundColor: "#7e847b",
            height: "100%",
            overflowY: "auto",
          }}
        >
          <Select
            defaultValue={0}
            style={{ width: "50%" }}
            onChange={handleChange}
          >
            <option value={0}>SMHI</option>
            <option value={1}>BrottsplatsKartan</option>
            <option value={2}>VMA</option>
            <option value={3}>Trafikverket</option>
            <option value={4}>SL</option>
          </Select>
          <Button className="setButtonInTile" style={{marginLeft:"5px"}} onClick={() => setAPI()}>
            Välj
          </Button>
          <div>
            <Button
              className="removeTileButton"
              onClick={() => removeBlock(id)}
              style={{marginTop:"5px"}}
            >
              Ta bort kort
            </Button>
          </div>
        </Card>
      )}
    </>
  );
};

export default Tile;
